import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { BaseTransformer } from './BaseTransformer';
export var TownTransformer = /*#__PURE__*/function (_BaseTransformer) {
  _inherits(TownTransformer, _BaseTransformer);
  var _super = _createSuper(TownTransformer);
  function TownTransformer() {
    _classCallCheck(this, TownTransformer);
    return _super.apply(this, arguments);
  }
  _createClass(TownTransformer, null, [{
    key: "fetch",
    value: function fetch(data) {
      return {
        label: data.town_name,
        value: data.record_id
      };
    }
  }, {
    key: "send",
    value: function send(data) {
      return {};
    }
  }]);
  return TownTransformer;
}(BaseTransformer);